module.exports = __webpack_public_path__ + "/static/sito/landing/agenti-zero-emissioni/media/Lezione_1.2_9.4489241d.pdf";